export default "__VITE_ASSET__CosebmA5__"